var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 2.25v1.5H3.75v10.5h10.5V10.5h1.5V15a.75.75 0 0 1-.75.75H3a.75.75 0 0 1-.75-.75V3A.75.75 0 0 1 3 2.25h4.5Zm5.69 1.5H9.75v-1.5h6v6h-1.5V4.81L9 10.06 7.94 9l5.25-5.25Z",
    fill: "#25241D"
  })));
};

export { SvgLink as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuNSAyLjI1VjMuNzVIMy43NVYxNC4yNUgxNC4yNVYxMC41SDE1Ljc1VjE1QzE1Ljc1IDE1LjE5ODkgMTUuNjcxIDE1LjM4OTcgMTUuNTMwMyAxNS41MzAzQzE1LjM4OTcgMTUuNjcxIDE1LjE5ODkgMTUuNzUgMTUgMTUuNzVIM0MyLjgwMTA5IDE1Ljc1IDIuNjEwMzIgMTUuNjcxIDIuNDY5NjcgMTUuNTMwM0MyLjMyOTAyIDE1LjM4OTcgMi4yNSAxNS4xOTg5IDIuMjUgMTVWM0MyLjI1IDIuODAxMDkgMi4zMjkwMiAyLjYxMDMyIDIuNDY5NjcgMi40Njk2N0MyLjYxMDMyIDIuMzI5MDIgMi44MDEwOSAyLjI1IDMgMi4yNUg3LjVaTTEzLjE4OTUgMy43NUg5Ljc1VjIuMjVIMTUuNzVWOC4yNUgxNC4yNVY0LjgxMDVMOSAxMC4wNjA1TDcuOTM5NSA5TDEzLjE4OTUgMy43NVoiIGZpbGw9IiMyNTI0MUQiLz4KPC9zdmc+Cg==";